export function convertToHumanReadable(timestamp: string): string {
  const parts = timestamp.split(':');

  const hours = parseInt(parts[0], 10).toString().padStart(2, '0');
  const minutes = parseInt(parts[1], 10).toString().padStart(2, '0');
  const seconds = Math.floor(parseFloat(parts[2])).toString().padStart(2, '0');

  const humanReadableFormat = `${hours}:${minutes}:${seconds}`;

  return humanReadableFormat;
}

export function convertToHumanReadableSeconds(seconds: string): string {
  const sec = Number(seconds);
  const hrs = Math.floor(sec / 3600);
  const min = Math.floor((sec - hrs * 3600) / 60);
  const actualSec = Math.floor(sec - hrs * 3600 - min * 60);

  const hrsStr = hrs < 10 ? `0${hrs}` : hrs.toString();
  const minStr = min < 10 ? `0${min}` : min.toString();
  const secStr = actualSec < 10 ? `0${actualSec}` : actualSec.toString();

  return `${hrsStr}:${minStr}:${secStr}`;
}
